var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fileEditDropdown" },
    [
      _c(
        "el-popover",
        {
          ref: "popover",
          attrs: {
            width: "146",
            trigger: "click",
            "append-to-body": false,
            placement: "bottom-end",
          },
          on: { show: _vm.listShow, hide: _vm.listHide },
        },
        [
          _c(
            "div",
            { staticClass: "operate" },
            _vm._l(_vm.getOptions, function (item, index) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hiddenList(item),
                      expression: "hiddenList(item)",
                    },
                  ],
                  key: index,
                  staticClass: "item",
                  class: [item.type == "error" && "error"],
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handlerClick(item.value)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(item.lable) + " ")]
              )
            }),
            0
          ),
          _c("span", { attrs: { slot: "reference" }, slot: "reference" }, [
            _c("img", {
              staticClass: "more-icon",
              attrs: { src: _vm.getDarkIcon("more") },
            }),
          ]),
        ]
      ),
      _c("rename", {
        attrs: { visible: _vm.visible, rename: _vm.item.fileNameStr },
        on: {
          "update:visible": function ($event) {
            _vm.visible = $event
          },
          changeName: _vm.fileRename,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }